var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMailRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_220_3580)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.77365 3.96954L9.41069 10.5187C10.8582 11.9437 13.2245 11.9449 14.6732 10.5187L21.3103 3.96954C21.326 3.95415 21.338 3.93555 21.3456 3.91505C21.3532 3.89454 21.3561 3.87264 21.3542 3.8509C21.3522 3.82916 21.3455 3.80811 21.3343 3.78924C21.3232 3.77037 21.308 3.75414 21.2898 3.74171C20.6129 3.27606 19.7893 3 18.9021 3H5.18193C4.29467 3 3.47104 3.27611 2.79409 3.74171C2.7759 3.75414 2.76071 3.77037 2.74959 3.78924C2.73847 3.80811 2.73169 3.82916 2.72974 3.8509C2.72779 3.87264 2.73071 3.89454 2.7383 3.91505C2.74589 3.93555 2.75796 3.95415 2.77365 3.96954ZM1 7.1247C0.999461 6.45927 1.16342 5.80374 1.47767 5.21491C1.48864 5.19415 1.50443 5.17624 1.52374 5.16263C1.54305 5.14902 1.56534 5.14009 1.58881 5.13658C1.61227 5.13306 1.63625 5.13506 1.65878 5.1424C1.68132 5.14975 1.70178 5.16223 1.7185 5.17885L8.27152 11.6423C10.3466 13.692 13.7361 13.6932 15.8125 11.6423L22.3655 5.17885C22.3822 5.16223 22.4027 5.14975 22.4252 5.1424C22.4477 5.13506 22.4717 5.13306 22.4952 5.13658C22.5186 5.14009 22.5409 5.14902 22.5602 5.16263C22.5796 5.17624 22.5953 5.19415 22.6063 5.21491C22.9205 5.80375 23.0845 6.45927 23.084 7.1247V15.7353C23.084 18.0114 21.2068 19.86 18.9021 19.86H5.18193C2.8772 19.86 1 18.0114 1 15.7353V7.1247Z",
    fill: "#A91B1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_220_3580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.4745,
    height: 22.4745,
    fill: "white",
    transform: "translate(0.638672 0.15625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMailRed);
export default __webpack_public_path__ + "static/media/icon_mail_red.acafc6dd2c9f3cd8ad9ea3203057c2c0.svg";
export { ForwardRef as ReactComponent };